import { useEffect, useState } from 'react';
import {
  getCRMMarketInsights,
  getMarketInsightCategories,
} from 'utils/principal-service/crm-endpoints';
import {
  AssignedCountry,
  AssignedMarketSegment,
} from '../../utils/principal-service/dto/Assignments.dto';
import { InsightCategory, MarketInsight } from '../../utils/types';

export type MarketInsightsFilter = {
  countries: AssignedCountry[] | null;
  marketSegments: AssignedMarketSegment[] | null;
  categories: InsightCategory[] | null;
  maxAgeInDays: number | null;
};

export type MarketInsightsRequest = {
  principalId: string;
  filters: MarketInsightsFilter | null;
  sortOrder: 'asc' | 'desc' | null;
};

export const useCRMMarketInsights = ({
  principalId,
  filters,
  sortOrder,
}: MarketInsightsRequest): { data: MarketInsight[]; isLoading: boolean } => {
  const [data, setData] = useState<MarketInsight[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setData([]);
    setIsLoading(true);

    async function getInsights() {
      const insights = await getCRMMarketInsights({
        principalId,
        filters,
        sortOrder,
      });
      setData(
        insights.map((i) => ({
          ...i,
          publishedAt: i.publishedAt ? new Date(i.publishedAt) : null,
        })),
      );
      setIsLoading(false);
    }

    getInsights();
  }, [principalId, filters, sortOrder]);

  return { data, isLoading };
};

export const useCRMMarketInsightsCategories = (
  selectedPrincipal: string,
): {
  data: { id: string; name: string }[];
  isLoading: boolean;
} => {
  const [data, setData] = useState<{ id: string; name: string }[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setData([]);
    setIsLoading(true);

    async function getCategories() {
      const categories = await getMarketInsightCategories(selectedPrincipal);
      setData(categories);
      setIsLoading(false);
    }

    getCategories();
  }, [selectedPrincipal]);

  return { data, isLoading };
};
